import { jsx } from 'react/jsx-runtime';
import { useContext, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { MultiSelectDropdown } from '../../MultiSelectDropdown/MultiSelectDropdown.es.js';
import { TableFiltersContext } from '../Context/TableFilters.Context.es.js';
import { useFilterSize } from '../TableFilters.Filter.es.js';

const FilterMultiSelectDropdown = ({ start, size, name, items, onChange, self, className, ...props })=>{
    const classes = useFilterSize({
        start,
        size
    });
    const { filters, setFilter } = useContext(TableFiltersContext);
    const handleChange = useCallback((listItems)=>{
        setFilter(name, listItems.map((listItem)=>listItem.value), self);
        onChange?.(listItems);
    }, [
        name,
        onChange,
        self,
        setFilter
    ]);
    const selectedItems = useMemo(()=>{
        const itemValues = filters?.[name] ?? [];
        return items.filter((item)=>{
            if (Array.isArray(itemValues) && item.value !== undefined) {
                return itemValues.includes(item.value);
            }
            return false;
        });
    }, [
        filters,
        items,
        name
    ]);
    return jsx(MultiSelectDropdown, {
        ...props,
        className: classNames(classes, className),
        "data-testid": `table-filter-multi-select-dropdown-${name}`,
        intent: "filter",
        items: items,
        onChange: handleChange,
        selectedItems: selectedItems,
        children: jsx(MultiSelectDropdown.Options, {
            items: items
        })
    });
};
FilterMultiSelectDropdown.displayName = 'TableCard.Filters.MultiSelectDropdown';

export { FilterMultiSelectDropdown };
//# sourceMappingURL=MultiSelectDropdown.es.js.map
